import { DecoratorNode, $applyNodeReplacement, $getRoot, $isElementNode } from 'lexical';
import { markRaw, defineAsyncComponent } from 'vue';

// Async: a static import would drag ProjectExplorer (stores/services) into every bundle using the node list.
const EditorProjectCarousel = markRaw(defineAsyncComponent(() => import('../Components/EditorProjectCarousel.vue')));

export class ProjectCarouselNode extends DecoratorNode {
    __searchParams;

    static getType() {
        return 'projectCarousel';
    }

    static clone(node) {
        return new ProjectCarouselNode(node.__searchParams, node.__key);
    }

    constructor(searchParams, key) {
        super(key);
        this.__searchParams = searchParams || {};
    }

    static importJSON(serializedNode) {
        const { searchParams } = serializedNode;
        return $createProjectCarouselNode({ searchParams });
    }

    exportJSON() {
        return {
            type: 'projectCarousel',
            version: 1,
            searchParams: this.__searchParams,
        };
    }

    exportDOM() {
        // Marker holds doc-order index; ContentRenderer pairs searchParams by index (survives markup transforms).
        const div = document.createElement('div');
        div.setAttribute('data-project-carousel', String($carouselIndexOf(this)));
        return { element: div };
    }

    isInline() {
        return false;
    }

    createDOM() {
        return document.createElement('div');
    }

    updateDOM(prevNode) {
        return JSON.stringify(prevNode.__searchParams) !== JSON.stringify(this.__searchParams);
    }

    decorate(editor) {
        return {
            component: EditorProjectCarousel,
            props: {
                searchParams: this.__searchParams,
                editable: editor.isEditable(),
            },
        };
    }

    updateData({ searchParams }) {
        const writable = this.getWritable();
        writable.__searchParams = searchParams;
    }
}

function $carouselIndexOf(node) {
    let index = 0;
    let found = false;

    const walk = (current) => {
        if (found) return;
        if ($isProjectCarouselNode(current)) {
            if (current.getKey() === node.getKey()) {
                found = true;
            }
            else {
                index++;
            }
            return;
        }
        if ($isElementNode(current)) {
            current.getChildren().forEach(walk);
        }
    };

    walk($getRoot());
    return index;
}

export function $createProjectCarouselNode({ searchParams }) {
    return $applyNodeReplacement(new ProjectCarouselNode(searchParams || {}));
}

export function $isProjectCarouselNode(node) {
    return node instanceof ProjectCarouselNode;
}
